module.exports = __webpack_public_path__ + "static/Hero-cc49f70b85e3d0fa6e106e36bdec3303.jpg";